var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-list',{staticClass:"data-table-fixed-10",attrs:{"headers":_vm.headers,"items":_vm.logs.data,"page-num":_vm.logs.pageNum,"page-size":_vm.logs.pageSize,"page-total":_vm.logs.total,"loading":_vm.logs.loading},on:{"pageChange":_vm.onPageChange},scopedSlots:_vm._u([{key:"item.processingTime",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.renderProcessingTime(item))+" ")]}},{key:"item.applyStatus",fn:function(ref){
var item = ref.item;
return [_c('span',{class:_vm.statusColor(item)},[_vm._v(_vm._s(item.statusDisplay))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }